/* eslint-disable camelcase */
import fetch from 'isomorphic-fetch'
import parse from 'url-parse'
import configFromParams from '../lib/params.js'
import { restoreMacmillanData, isLcrpAvailable } from '../lib/macmillan'
import { buildLearningCurve, applyConfigOverrides } from '../lib/legacy/legacyActivityBuilder'
import { ANALYTICS_MIDDLEWARE_KEY } from '../middleware/analytics'

import {
  simulateInstructorData,
  finishInitialization
} from '../lib/legacy/legacyArgaService'

import {
  ACTIVITY_REQUEST,
  ACTIVITY_SUCCESS,
  ACTIVITY_FAILURE,
  loadProgress,
  loadStudentRoster,
  initAssignment,
  loadActivityCompletionTime
} from '../actions'

import {
  loadLCRPActivityState
} from '../../lcrp/actions'

const { demo, course_id } = parse(window.location, true).query

export default (endpoint, preload) => {
  return (dispatch) => {
    dispatch({ type: ACTIVITY_REQUEST })
    return fetch(endpoint)
      .then(res => res.text().then(text => ({ text, res })))
      .then(({ text, res }) => {
        if (res.ok) {
          const config = configFromParams(window.location)
          const activity = buildLearningCurve(text, config)

          if (config.isInstructorView && (config.testMode || config.demo)) {
            if (config.itemId) {
              dispatch(loadStudentRoster({ assignmentId: config.itemId, courseId: course_id }))
            } else {
              simulateInstructorData(activity)
            }
          } else {
            if (preload) {
              restoreMacmillanData(activity, preload)
            }

            if (config.isInstructorView) {
              dispatch(loadStudentRoster({ assignmentId: activity.config.itemId, courseId: course_id }))
            }
          }

          // includes topic exclusions that must be done after restoreArgaData
          applyConfigOverrides(activity)
          finishInitialization(activity)

          dispatch(initAssignment(activity)).then(() => {
            dispatch(loadActivityCompletionTime({
              assignmentId: activity.config.itemId
            }))
          })
          if (demo) {
            dispatch(loadProgress({
              userId: demo,
              userIdType: 'macmillan',
              assignmentId: `demo_assignment_${demo}`
            }))
          } else {
            dispatch(loadProgress({
              userId: activity.studentData.user_id,
              userIdType: activity.studentData.user_id_type,
              assignmentId: activity.config.itemId
            }))

            if (isLcrpAvailable()) {
              dispatch(loadLCRPActivityState({
                userId: activity.studentData.user_id,
                assignmentId: activity.config.itemId,
                courseId: course_id
              }))
            }
          }
          // forcing the correct user_rights for instructor, regardless of environment.
          // Analytics helped to discover an issue: see MLLC-967
          if (config.isInstructorView) {
            activity.studentData.user_rights = '3_instructor'
            const asssignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate
            const dataObj = {
              uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              userData: activity.studentData,
              actTitle: activity.activityTitle,
              actEndp: activity.config.file + '.txt',
              user_id: activity.studentData.user_id,
              assignmentId: activity.studentData.assignmentId,
              activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
              selectionTimeUTC: new Date().getTime()
            }
            if (asssignmentDate) {
              dataObj.dueDate = asssignmentDate
            }
            return dispatch({
              type: ACTIVITY_SUCCESS,
              payload: activity,
              [ANALYTICS_MIDDLEWARE_KEY]: ['event',
                [{
                  category: 'Activity',
                  action: 'Activity Loaded Successfully: Instructor',
                  label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
                  data: dataObj
                }]]
            })
          }

          return dispatch({
            type: ACTIVITY_SUCCESS,
            payload: activity,
            [ANALYTICS_MIDDLEWARE_KEY]: ['event',
              [{
                category: 'Activity',
                action: 'Activity Loaded Successfully',
                label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
                data: {
                  uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
                  userData: activity.studentData,
                  actTitle: activity.activityTitle,
                  actEndp: activity.config.file + '.txt',
                  user_id: activity.studentData.user_id,
                  assignmentId: activity.studentData.assignmentId,
                  activityType: isLcrpAvailable() ? 'LCRP' : 'LC Classic',
                  selectionTimeUTC: new Date().getTime()
                }
              }]]
          })
        } else {
          return dispatch({ type: ACTIVITY_FAILURE })
        }
      })
  }
}
